module.exports = __webpack_public_path__ + "static/illustration-dd194f9ea1e75cc60e4d43dbb78ee82f.svg";